import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { processActions } from "../../reducer/processReducer";
import logoSplash from "../../images/logo_splash.png";

class Suspended extends Component {
  componentDidMount() {
    document.title = "Ограничен достъп - A1 Xplore TV GO";

    const { history, process, resetEmail } = this.props;

    if (process.isSuspended !== true) {
      history.push("/start");
      return false;
    }

    resetEmail();
    return false;
  }

  handleNextClick = () => {
    window.location.href = "https://new.a1xploretv.bg";
    return false;
  };

  render() {
    const { history } = this.props;

    return (
      <div className="page page-confirm">
        <div className="header-bg" />

        <div className="container container--small">
          <div className="container-head">
            <img src={logoSplash} alt="" />
            <button type="button" className="tag-btn--back" onClick={history.goBack}>
              <i className="a1now-icon-arrow_left" /> НАЗАД
            </button>
          </div>
          <div className="container-body">
            <h1 className="tag-title">A1 Xplore TV GO</h1>

            <div className="tag-content">
              <p>
                Здравей, към днешна дата имаш просрочени задължения, вследствие на което твоята услуга A1 Xplore TV GO е
                ограничена.
              </p>
            </div>

            <div className="tag-content" style={{ marginTop: "80px" }}>
              <button type="button" className="tag-btn tag-btn--active" onClick={this.handleNextClick}>
                Плати онлайн
              </button>
            </div>

            <div className="tag-content tag-content__help" style={{ marginTop: "80px" }}>
              Имаш въпроси?{" "}
              <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
                Помощ
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetEmail: () => dispatch(processActions.resetEmail()),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Suspended);
